/**
 * Growth Hub → Open house finder（/app/openhousefinder）。
 * 打开页面打 STATSIG.COMMON.VIEW，value=open_house_finder。
 *
 * 正在用：打开 Finder；按地点/距离 Search 出结果；点 Agent 打开中介浮层；
 * 复制地址 / 电话 / 邮箱。
 * 已不算：改距离没点 Search、价格筛选、排序、翻页、展开 AMI/MFI、
 * 关浮层、地址 tooltip、面包屑回 Growth Hub。
 * 免费拦截在 Growth Hub 首页打，不在这里。
 * Settings Open House Sign-in、Luxury Open House flyer 不跨模块。
 */
export enum GrowthHubOpenHouseFinderEvent {
    /**
     * Search 出结果（含 0 条）。
     * 属性 result_count
     */
    SEARCH = 'OPEN_HOUSE_FINDER_SEARCH',
    /** 点 Agent 打开中介浮层 */
    AGENT_OPEN = 'OPEN_HOUSE_FINDER_AGENT_OPEN',
    /**
     * 复制联系信息。
     * 属性 type=address|phone|email
     */
    COPY = 'OPEN_HOUSE_FINDER_COPY',
}
